import store from "../../../store";
import { BrowserKinds, BrowserUtility, UrlSchemeClient } from "../../../utilities";
import { LoggerFactory } from "../../../utilities/logger";

export class MessageBroadcaster {
  static sendTo(path: string, message: string): void {
    if (BrowserUtility.getBrowserKind() !== BrowserKinds.InternetExplorer) {
      // TODO
      // 現状はwindow.opener経由とMessageBroadcaster経由の2通りの通知ルートがあるが、
      // それぞれで通知を受け取る対象が異なっている（親ウィンドウのみ or 全ウィンドウのうち指定したpathのもの）
      // window.openerの有無とwindow.opener.isEnableで分岐しているところを無くして処理を一本化するのが自然に見える。
      // また、Chromium系のブラウザの場合はAssistant経由の通知ではなくBroadcastChannel経由で他ウィンドウに通知を飛ばせる可能性がある。
      // （IEの場合はAssistant経由で通知・Chromium系のブラウザの場合はBroadcastChannel経由で通知するなど）
      this._logger.debug("Assistantのbroadcast機能はIE以外のブラウザについては未実装のため、要求をスキップします。");
      return;
    }
    this._logger.debug("Assistantへbroadcastを要求します.");
    this._logger.debug(path);
    this._logger.debug(message);
    const configuration = store.state.configuration.behavior.localhost;
    const client = new UrlSchemeClient();
    client.request(configuration.schemeUrlPrefix + "?action=broadcast&path=" + btoa(path) + "&message=" + btoa(message));
  }

  private static readonly _logger = LoggerFactory.getLogger();
}
